import { Button, Group } from '@mantine/core';
import { AlertBanner } from '@shipstation/client-common/components/alert-banner';
import { ModalContent } from '@shipstation/client-common/components/modal-content';
import { ModalFooter } from '@shipstation/client-common/components/modal-footer';
import { FormattedMessage } from 'react-intl';

import { UsageOverview } from './usage-overview';
import { messages } from '../../purchase-shipment-volume/messages';

type ReadonlyContentProps = {
  onClose: () => void;
  isAtLimit: boolean;
  isHighLimitWarning: boolean;
  isMediumLimitWarning: boolean;
  usagePercentage: number;
  totalUsage: number;
  shipmentLimit: number;
  planName: string;
};

export const ReadonlyContent = ({
  onClose,
  isAtLimit,
  isHighLimitWarning,
  isMediumLimitWarning,
  usagePercentage,
  totalUsage,
  shipmentLimit,
  planName,
}: ReadonlyContentProps) => {
  let bodyMessage = messages.purchaseAdditionalShipmentsBody;
  if (isAtLimit) {
    bodyMessage = messages.atLimitBody;
  } else if (isHighLimitWarning || isMediumLimitWarning) {
    bodyMessage = messages.approachingLimitBody;
  }

  return (
    <>
      <ModalContent>
        <UsageOverview
          bodyMessage={bodyMessage}
          isHighLimitWarning={isHighLimitWarning}
          isMediumLimitWarning={isMediumLimitWarning}
          isAtLimit={isAtLimit}
          planName={planName}
          shipmentLimit={shipmentLimit}
          totalUsage={totalUsage}
          usagePercentage={usagePercentage}
        />
        <AlertBanner description={<FormattedMessage {...messages.contactBillingAdministrator} />} status='inform' />
      </ModalContent>
      <ModalFooter>
        <Group justify='flex-end' w='100%'>
          <Button onClick={onClose} variant='ghost'>
            <FormattedMessage {...messages.cancel} />
          </Button>
        </Group>
      </ModalFooter>
    </>
  );
};
